/** 
 * @type {import("./defs").StoreProject} 
 */
const store = {
}
/** 
* @returns {import("./defs").StoreProject} 
*/
export default function () {
    return JSON.parse(JSON.stringify(store));
}


// WEBPACK FOOTER //
// ./resources/js/storers/StoreProject.js